import { Injectable } from '@angular/core';
import { Either, Left, Right } from 'purify-ts';
import {
  IMediaRepository,
  MediaRepositoryFailure,
  UploadedMedia,
} from '../../domain/media/i-media-repository';

@Injectable({
  providedIn: 'root',
})
export class FakeMediaRepository implements IMediaRepository {
  public async upload(
    _companyPhoneNumber: string,
    file: File
  ): Promise<Either<MediaRepositoryFailure, UploadedMedia>> {
    return Right({
      mediaId: `fake-media-${crypto.randomUUID()}`,
      mimeType: file.type,
      fileName: file.name,
    });
  }

  public async getMediaObjectUrl(): Promise<Either<MediaRepositoryFailure, string>> {
    return Left(MediaRepositoryFailure.expired());
  }
}
